import React from "react";
import { useLang } from "@/context/LanguageContext";
import { HeartHandshake, ArrowUpRight } from "lucide-react";

const WHEAT = "https://images.unsplash.com/photo-1666631740049-5643ffd94b7c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHx3aGVhdCUyMGZpZWxkJTIwZ29sZGVuJTIwaG91ciUyMGNhbG18ZW58MHx8fHwxNzgzOTc4MDE3fDA&ixlib=rb-4.1.0&q=85";

export default function Mission() {
  const { t } = useLang();
  return (
    <div data-testid="mission-page">
      <section className="container-refined pt-14 pb-10 grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <p className="eyebrow">{t("mission.eyebrow")}</p>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl leading-[1.05] text-forest-900">{t("mission.title")}</h1>
        </div>
        <div className="lg:col-span-5">
          <div className="rounded-[2rem] overflow-hidden">
            <img src={WHEAT} alt="Wheat field" className="w-full h-72 md:h-96 object-cover" />
          </div>
        </div>
      </section>

      <section className="container-refined py-16 grid md:grid-cols-2 gap-14 max-w-6xl">
        <div className="space-y-8 text-forest-700 leading-relaxed text-lg">
          <p>{t("mission.p1")}</p>
          <p>{t("mission.p2")}</p>
        </div>
        <div className="space-y-8 text-forest-700 leading-relaxed text-lg">
          <p>{t("mission.p3")}</p>
          <p>{t("mission.p4")}</p>
        </div>
      </section>

      <section className="container-refined pb-24">
        <div className="card-warm flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <p className="eyebrow"><HeartHandshake className="inline h-3.5 w-3.5 mr-1" strokeWidth={1.5}/> Ukraine</p>
            <h2 className="mt-3 font-serif text-3xl text-forest-900">Support Dzyga&apos;s Paw</h2>
            <p className="mt-2 text-forest-700 max-w-2xl">Dzyga&apos;s Paw is a Ukrainian charitable foundation supporting the defenders and communities of Ukraine. Every act of solidarity counts.</p>
          </div>
          <a data-testid="mission-dzyga-cta" href="https://dzygaspaw.com/en" target="_blank" rel="noreferrer" className="btn-primary shrink-0">
            {t("mission.dzyga_cta")} <ArrowUpRight className="h-4 w-4" strokeWidth={1.5}/>
          </a>
        </div>
      </section>

      <section className="container-refined pb-24" data-testid="dzyga-manifesto">
        <div className="max-w-3xl">
          <p className="eyebrow">{t("dzyga_manifesto.eyebrow")}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl text-forest-900 leading-[1.1]">{t("dzyga_manifesto.title")}</h2>
          <p className="mt-6 text-forest-700 leading-relaxed text-lg">{t("dzyga_manifesto.intro")}</p>
          <div className="mt-8 space-y-6">
            {(t("dzyga_manifesto.paragraphs") || []).map((p, i) => (
              <p key={i} className="text-forest-700 leading-relaxed" data-testid={`dzyga-para-${i}`}>{p}</p>
            ))}
          </div>
          <div className="mt-10 flex flex-wrap gap-3">
            <a href="https://dzygaspaw.com/en" target="_blank" rel="noreferrer" className="btn-primary" data-testid="dzyga-manifesto-cta">
              {t("mission.dzyga_cta")} <ArrowUpRight className="h-4 w-4" strokeWidth={1.5}/>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
